import { Skeleton } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { AppIcon } from '~/components/atoms/AppIcon';
import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { Heading } from '~/components/molecules/Heading';
import { SearchArticles } from '~/components/organisms/SearchArticles';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';

export type IAppSearchPageProps = {
  appId: string;
};

export const AppSearchPage: React.FC<IAppSearchPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  const appQuery = useAppQuery({ appId });

  const appName = appQuery.data?.name;
  const pageName = appName;
  const pageTitle = appName ?? t('AppSearchPage.seo.title');

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <Heading
        icon={
          <Skeleton loaded={!appQuery.isLoading}>
            <AppIcon app={appQuery.data} />
          </Skeleton>
        }
        previousUrl={`/apps/${appId}/content`}
        title={
          <QuerySkeleton query={appQuery} length={{ min: 8, max: 16 }}>
            {pageName}
          </QuerySkeleton>
        }
      />

      <SearchArticles appId={appId} />
    </>
  );
};
